import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Admin = () => {
  const [inquiries, setInquiries] = useState([]);
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState('');

  // The correct password - in a real app, this would be handled securely on a backend
  const correctPassword = 'socialcrouton2024'; // This is just for demo purposes

  useEffect(() => {
    // Load inquiries from localStorage
    const storedInquiries = localStorage.getItem('inquiries');
    if (storedInquiries) {
      setInquiries(JSON.parse(storedInquiries));
    }
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === correctPassword) {
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Incorrect password');
    }
  };

  const handleDeleteInquiry = (index) => {
    const updatedInquiries = [...inquiries];
    updatedInquiries.splice(index, 1);
    setInquiries(updatedInquiries);
    localStorage.setItem('inquiries', JSON.stringify(updatedInquiries));
  };

  if (!isAuthenticated) {
    return (
      <section className="py-16 bg-gradient-to-r from-light to-gray-100 min-h-screen">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="max-w-md mx-auto bg-white p-8 rounded-lg shadow-md"
          >
            <h1 className="mb-6 text-2xl font-bold text-center font-display">
              Admin <span className="text-primary">Login</span>
            </h1>
            
            {error && (
              <div className="mb-4 p-3 bg-red-100 text-red-700 rounded">
                {error}
              </div>
            )}
            
            <form onSubmit={handleLogin}>
              <div className="mb-4">
                <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-700">
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                  required
                />
              </div>
              
              <button
                type="submit"
                className="w-full py-2 px-4 bg-primary text-white font-medium rounded-md hover:bg-opacity-90 transition-colors"
              >
                Login
              </button>
            </form>
          </motion.div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 bg-gradient-to-r from-light to-gray-100 min-h-screen">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-4xl mx-auto"
        >
          <div className="flex justify-between items-center mb-8">
            <h1 className="text-3xl font-bold font-display">
              Inquiry <span className="text-primary">Dashboard</span>
            </h1>
            <button
              onClick={() => setIsAuthenticated(false)}
              className="py-2 px-4 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
            >
              Logout
            </button>
          </div>
          
          {inquiries.length === 0 ? (
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
              <p className="text-gray-600">No inquiries yet.</p>
            </div>
          ) : (
            <div className="space-y-6">
              {inquiries.map((inquiry, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: index * 0.1 }}
                  className="bg-white p-6 rounded-lg shadow-md"
                >
                  <div className="flex justify-between items-start">
                    <div>
                      <h2 className="text-xl font-semibold mb-2">{inquiry.from_name}</h2>
                      <p className="text-gray-600 mb-1">
                        <strong>Email:</strong> {inquiry.from_email}
                      </p>
                      {inquiry.phone_number && (
                        <p className="text-gray-600 mb-1">
                          <strong>Phone:</strong> {inquiry.phone_number}
                        </p>
                      )}
                      {inquiry.company_name && (
                        <p className="text-gray-600 mb-1">
                          <strong>Company:</strong> {inquiry.company_name}
                        </p>
                      )}
                      {inquiry.service_interest && (
                        <p className="text-gray-600 mb-1">
                          <strong>Service Interest:</strong> {inquiry.service_interest}
                        </p>
                      )}
                      <p className="text-gray-600 mb-1">
                        <strong>Date:</strong> {new Date(inquiry.timestamp).toLocaleString()}
                      </p>
                    </div>
                    <button
                      onClick={() => handleDeleteInquiry(index)}
                      className="text-red-500 hover:text-red-700"
                      title="Delete inquiry"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                      </svg>
                    </button>
                  </div>
                  <div className="mt-4 p-4 bg-gray-50 rounded">
                    <p className="whitespace-pre-wrap">{inquiry.message}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default Admin;